module.exports = __webpack_public_path__ + "img/paracheirodon_innesi.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/paracheirodon_innesi.jpg
 ** module id = 142
 ** module chunks = 0
 **/